// Obuna (Q-064): to'lov oynasida yangi muddatni oldindan ko'rsatish. Server bilan bir xil qoida
// (supabase/migrations/20261025000500_billing.sql, platform_billing_pay): kunlar yo'qolmaydi.
import type { TenantStatus } from './types';

/** Oyni qo'shish: oy oxiri to'g'ri (31-yanvar + 1 oy = 28/29-fevral), PostgreSQL kabi */
export function addMonths(iso: string, months: number): string {
  const d = new Date(iso);
  const day = d.getUTCDate();
  const r = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + months, 1, d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds()));
  const last = new Date(Date.UTC(r.getUTCFullYear(), r.getUTCMonth() + 1, 0)).getUTCDate();
  r.setUTCDate(Math.min(day, last));
  return r.toISOString();
}

/** Davr qachondan boshlanadi */
export function payStart(
  t: { status: TenantStatus; trial_ends_at: string | null; paid_until: string | null },
  nowIso: string = new Date().toISOString(),
): string {
  const base = t.paid_until ?? t.trial_ends_at;
  if (t.status === 'suspended' || !base) return nowIso;
  if (t.status === 'trial') return t.trial_ends_at && Date.parse(t.trial_ends_at) > Date.parse(nowIso) ? t.trial_ends_at : nowIso;
  if (t.status === 'active' || t.status === 'grace') return base;
  return nowIso;
}

/** To'lov oynasi: summa hisoblangandan farq qiladimi (sabab majburiy) */
export function amountDiffers(amount: number | null, quoted: number | null | undefined): boolean {
  return quoted != null && amount !== null && amount !== quoted;
}
